import React, { Component } from 'react';
import DiskussionenItem from '../components/DiskussionenItem'; 
import Equalizer from 'react-equalizer';

class Diskussionen extends Component {
	componentWillMount(){
		window.addEventListener('resize', function(){
            if(window.innerWidth<992){
				let total = document.getElementsByClassName('article-item');
				for(let i=0;i<total.length;i++){
					total[i].removeAttribute('style');
				}
			}
        })
	}
	render(){
		return(			
			<Equalizer className="row" enabled={() => window.matchMedia("(min-width: 992px)").matches}>
				{
					this.props.children.map( (data,i)=>
						<DiskussionenItem {...data} key={i} />
					) 
				}
			</Equalizer>
		)
	}	
}
export default Diskussionen;


// WEBPACK FOOTER //
// ./src/components/Diskussionen.js